import { RemotePropertiesControllerService, SegmentProperty } from 'api';

export const fetchMeetRemoteProperties = async (): Promise<SegmentProperty[] | null> => {
    try {
        // Для получения фича-флагов используем одно и то же API мессенджера и Meet.
        // Поэтому необходимо передавать версию мита и платформу при каждом запросе.
        const { error, payload } = await RemotePropertiesControllerService.getProperties({
            platform: 'WEB_MEET',
            version: process.env.REACT_APP_VERSION || '1.0.0',
        });

        if (error) {
            console.log(error);
            return null;
        }

        if (payload) {
            return payload;
        }
        return null;
    } catch (e) {
        console.log(e);
        return null;
    }
};
